import { CanActivateFn } from '@angular/router';

import { environment } from '@env/environment';

export const featureCheckGuard = (featureName: string): CanActivateFn => {
  return () => {
    const allowedFeatures = environment.allowedFeatures ?? [];
    return allowedFeatures.includes(featureName);
  };
};
